module.exports = __webpack_public_path__ + "static/media/bg 03.d85573b6.png";